// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------
const year = new Date().getFullYear()
const cn = {
  demo: {
    title: `Chinese`,
    introduction: `Lorem Ipsum 只是印刷和排版行业的虚拟文本。 自 1500 年代以来，Lorem Ipsum 一直是行业的标准虚拟文本，当时一位不知名的印刷商采用了一种类型的厨房并将其加扰以制作类型样本书。 它不仅经历了五个世纪，而且经历了电子排版的飞跃，基本保持不变。 它在 1960 年代随着包含 Lorem Ipsum 段落的 Letraset 表的发布而流行起来，最近还随着 Aldus PageMaker 等桌面出版软件（包括 Lorem Ipsum 的版本）而普及.`,
  },
  docs: {
    hi: `你好`,
    description: `需要帮忙？\n 请查看我们的文档.`,
    documentation: `文件`,
  },
  app: `应用程序`,
  user: `用户`,
  list: `列表`,
  edit: `编辑`,
  shop: `商店`,
  blog: `博客`,
  post: `邮政`,
  mail: `电子邮件`,
  chat: `聊天`,
  cards: `牌`,
  posts: `帖子`,
  create: `创建`,
  kanban: `登机`,
  general: `一般的`,
  banking: `银行业`,
  booking: `预订`,
  profile: `轮廓`,
  account: `帐户`,
  product: `产品`,
  invoice: `发票`,
  details: `细节`,
  checkout: `退房`,
  calendar: `日历`,
  analytics: `分析`,
  ecommerce: `电子商务`,
  management: `管理`,
  menu_level_1: `菜单级别 1`,
  menu_level_2a: `菜单级别 2a`,
  menu_level_2b: `菜单级别 2b`,
  menu_level_3a: `菜单级别 3a`,
  menu_level_3b: `菜单级别 3b`,
  menu_level_4a: `菜单级别 4a`,
  menu_level_4b: `菜单级别 4b`,
  item_disabled: `项目已禁用`,
  item_label: `项目标签`,
  item_caption: `项目标题`,
  item_external_link: `项目外部链接`,
  description: `描述`,
  other_cases: `其他情况`,
  item_by_roles: `按角色逐项`,
  only_admin_can_see_this_item: `只有管理员可以看到这个项目`,

  header: {
    about: '关于',
    contact: '接触',
    pricing: '价钱',
    ReportAbuse: '报告滥用',
    InvitationSystem: '邀请系统',
    verify_email: '验证邮件',
    sign_in: '登入',
    dashboard: '仪表板',
    biolink_page: '生物链接页面',
    admin: '行政',
    logout: '登出',
    sign_up: '报名',
    about_us: '关于我们',
    name: '丹尼尔·琼斯',
    post: '首席执行官兼创始人',
    contact_us: '联系我们',
    payments_list: '付款清单',
  },
  footer: {
    terms_conditions: '条款及条件',
    privacy_policy: '隐私政策',
    copyright: '版权 © ' + year + ' bil.bio',
    Update_cookies_preferences: '管理Cookies',
  },
  biolink_title: {
    edit: '编辑',
    delete: '删除',
    delete_cap: '删除',
    save_cap: '节省',
    view: '看法',
    settings: '设置',
    duplicate: '复制',
    your_link_is: '你的链接是',
    copy_to_clipboard: '复制到剪贴板',
    copied: '已复制',
    change_status: '更改状态',
    edit_user: '编辑用户',
    block: '堵塞',
    november: '十一月',
    maximum: '最大限度',
  },

  auth: {
    create_your_account: '创建您的帐户',
    signup_to_bilbio_and_create_your_biolink_now:
      '立即注册 bilbio 并创建您的 Biolink!',
    pagename: '页面名称',
    enter_page_name: '输入页面名称',
    enter_page_email: '请输入电邮地址',
    by_creating_an_account_you_agreeing_to_our: '创建帐户即表示您同意我们的',
    log_in: '登录',
    create_account: 'CREATE ACCOUNT',
    hi_welcome_back: '你好，欢迎回来!',
    enter_you_details_to_login_into_your_bilbio_account:
      '输入您的详细信息以登录您的 bilbio 帐户',
    enter_password: '输入密码',
    login: '登录',
    sign_up: '报名',
    do_not_have_an_account: '还没有账号？',
    page_name_required: '页面名称必填',
    pass_required: '要求输入密码',
    this_username_is_already_taken: '该用户名已被使用',
    page_name_cannot_contain_symbols: '页面名称不能包含符号',
    forgot_your_password: '忘记密码了吗',
  },
  Invitation_System: {
    More_than_a_todo_app: '不仅仅是一个待办事项应用',
    paragraph:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Impedit quam eum facere explicabo, dolorum sed consequuntur incidunt, culpa cum voluptatem, eaque consectetur saepe rerum dolor? Cum eius labore debitis minus.',
    thanks_for_siging: '感谢您的注册',
    verify_your_email: '验证您的电子邮件',
    confirm_email: '请确认您要使用此电子邮件地址',
    verify_email: '验证电子邮件',
    bilbio_Account_activated: 'Bill Bio账户已激活',
    hello: '你好 John',
    email_verified: '谢谢，您的电子邮件已验证。您的账户现在已激活。',
    link_login_account: '请使用下面的链接登录您的账户',
    login_account: '登录账户',
    invite_friend: '邀请朋友',
    invite_friend_cap: '邀请朋友',
    you_have: '您有',
    credits: '积分',
    friend: '朋友',
    sent: '已发送',
  },
  about: {
    description_text:
      'Lorem Ipsum是印刷和排版业的虚拟文字。自1500年以来，Lorem Ipsum一直是行业的标准虚拟文字，当一名未知的印刷工匠拿起一篮子铅字，搅乱它以制作一本样本书。它不仅存活了五个世纪，而且还跃入了电子排版，基本保持不变。在1960年代推出包含Lorem Ipsum的Letraset样张后，它变得更加流行。',
    description_text_mobile:
      'Lorem Ipsum是印刷和排版业的虚拟文字。自1500年以来，Lorem Ipsum一直是行业的标准虚拟文字，当一名未知的印刷工匠拿起一篮子铅字，搅乱它以制作一本样本书。',
    team: '团队',
    meet_our_amazing: '了解我们的出色团队',
    view_all: '查看全部',
    get_in_touch: '联系我们',
  },

  front_end_pages: {
    home_page: {
      hero_section: {
        main_title_part_one: '建立一个单一链接',
        main_title_part_two: '对于您的所有链接',
        sub_title:
          '利用各种在线平台与志同道合的人互动，获得曝光，并为您的创意努力建立数字存在，所有这些都可以通过您的一个生物链接完成。',
      },
      features_section: {
        biolink: '生物链接',
        create: '创建',
        create_your: '创建您的',
        unique: '独特的',
        sec_one_first_line: '在几秒钟内轻松生成个性化的链接页面。',
        sec_one_sec_line: '将您的整个在线存在统一到一个链接中。',
        sec_one_thired_line: '用一个链接与您的粉丝分享一切。',
        sec_one_four_line: '个性化您的生物链接，使它们简短易记，更容易分享。',
        customize: '自定义',
        design: '设计',
        exceptional: '卓越的',
        sec_two_first_line: '轻松创建自己独特且高度可定制的生物链接页面。',
        sec_two_sec_line: '使用自定义颜色和品牌个性化您的生物链接。',
        sec_two_thired_line: '通过多个准备就绪的组件更轻松地体验。',
        sec_two_four_line:
          '添加您的Instagram、Twitter、Snapchat、TikTok、Youtube、社交媒体账户、图片等。',
        share: '分享',
        add_your_biolink_to_your: '将您的生物链接添加到您的',
        social_media: '社交媒体',
        handles: '账户',
        sec_thered_first_line:
          '将您定制的生物链接URL添加到所有平台，以接触您的观众。',
        sec_thered_sec_line: '通过自定义颜色和品牌个性化您的生物链接。',
        sec_thered_thired_line: '通过多个准备就绪的组件更轻松地体验。',
        sec_thered_four_line: '添加品牌和SEO优化。',
      },
      pricing_section: {
        subscription: '订阅',
        choose_a: '选择一个',
        plan: '计划',
        that_works_for_you: '适合您的计划',
        monthly: '每月',
        annual: '每年',
        what_included: '包括什么',
        unlimited_biolink_pages: '无限的Biolink页面',
        unlimited_biolink_blocks: '无限的Biolink块',
        bio_pages: '25个Biolink页面',
        seo_feature: 'SEO功能',
        brandings: '品牌',
        customer_support: '24*7客户支持',
      },
      create_page_section: {
        bilbio: '生物',
        start_creating_your_exclusive: '开始创建您的专属',
        start_creating_your_exclusive_bilbio: '开始创建您的专属生物链接',
        biolink_url: '生物链接 URL',
        now: '现在',
      },
      contact: {
        fill_up_your_contact: '填写您的联系方式',
        information_and_our_team: '信息和我们的团队',
        will_get_back_to_you: '我们会尽快回复您。',
        enter_first_name: '输入名字',
        enter_last_name: '输入姓氏',
        enter_phone_number: '输入电话号码',
        enter_email: '输入电子邮件地址',
        enter_message_here: '在此输入消息',
        last_name: '姓氏',
        phone_number: '电话号码',
        enter_valid_number: '输入有效的号码',
        message: '消息',
        last_name_required: '姓氏为必填项',
        phone_number_required: '电话号码为必填项',
        the_email_should_have_less_then_characters:
          '电子邮件长度应小于50个字符',
        message_required: '消息字段为必填项',
      },
    },

    about: {
      description_text:
        'Lorem Ipsum是印刷和排版业的虚拟文字。自1500年以来，Lorem Ipsum一直是行业的标准虚拟文字，当一名未知的印刷工匠拿起一篮子铅字，搅乱它以制作一本样本书。它不仅存活了五个世纪，而且还跃入了电子排版，基本保持不变。在1960年代推出包含Lorem Ipsum的Letraset样张后，它变得更加流行。',
      description_text_mobile:
        'Lorem Ipsum是印刷和排版业的虚拟文字。自1500年以来，Lorem Ipsum一直是行业的标准虚拟文字，当一名未知的印刷工匠拿起一篮子铅字，搅乱它以制作一本样本书。',
      team: '团队',
      meet_our_amazing: '了解我们的出色团队',
      view_all: '查看全部',
      get_in_touch: '联系我们',
    },
    contact: {
      fill_up_your_contact: '填写您的联系方式',
      information_and_our_team: '信息和我们的团队',
      will_get_back_to_you: '我们会尽快回复您。',
      enter_first_name: '输入名字',
      enter_last_name: '输入姓氏',
      enter_phone_number: '输入电话号码',
      enter_email: '输入电子邮件地址',
      enter_message_here: '在此输入消息',
      last_name: '姓氏',
      phone_number: '电话号码',
      enter_valid_number: '输入有效的号码',
      message: '消息',
      last_name_required: '姓氏为必填项',
      phone_number_required: '电话号码为必填项',
      the_email_should_have_less_then_characters: '电子邮件长度应小于50个字符',
      message_required: '消息字段为必填项',
    },
    pricing: {
      simple_plans_for: '为每个人提供简单的计划',
      everyone: '每个人',
      have_a_coupon: '有优惠券吗？',
      choose_your_plan_get_amazing_discounts_cancel_anytime:
        '选择您的计划。获得惊人的折扣。随时取消。',
      free_plan: '免费计划',
      premium_plan_paid: '高级计划（付费）',
    },
    privacy_policy: {
      lorem_ipsum_is_simply_dummy_text_of_the_printing:
        'Lorem Ipsum是印刷和排版业的虚拟文字。',
      lorem_ipsum_has_been_the_industry_standard_dummy_text:
        'Lorem Ipsum已经成为行业的标准虚拟文字。',
      what_is_lorem_ipsum: '什么是Lorem Ipsum？',
      first_para:
        'Lorem Ipsum只是印刷和排版业的虚拟文字。自1500年以来，Lorem Ipsum一直是行业的标准虚拟文字，当一名未知的印刷工匠拿起一篮子铅字，搅乱它以制作一本样本书。它不仅存活了五个世纪，而且还跃入了电子排版，基本保持不变。它是在1960年代与Letraset版本的发布中变得流行，其中包含Lorem Ipsum段落，并且最近在桌面排版软件中使用，如Aldus PageMaker，包括Lorem Ipsum版本。',
      second_para:
        'Lorem Ipsum只是印刷和排版业的虚拟文字。自1500年以来，Lorem Ipsum一直是行业的标准虚拟文字，当一名未知的印刷工匠拿起一篮子铅字，搅乱它以制作一本样本书。它不仅存活了五个世纪，而且还跃入了电子排版，基本保持不变。它是在1960年代与Letraset版本的发布中变得流行。',
      li_one:
        '与普遍的看法相反，Lorem Ipsum不仅仅是随机文本。它源于公元前45年的一部古典拉丁文学作品，有超过2000年的历史。',
      li_two:
        '弗吉尼亚州Hampden-Sydney学院的拉丁教授Richard McClintock查找了Lorem Ipsum段落中的一个更为晦涩的拉丁单词“consectetur”，并查阅了这个词在古典文学中的引用，发现了不容置疑的来源。',
      li_three:
        'Lorem Ipsum源自公元前45年西塞罗的《善恶之极》（The Extremes of Good and Evil）第1.10.32和1.10.33节。 ',
      li_four:
        '这本书是文艺复兴时期伦理学理论的论著。Lorem Ipsum的第一行“Lorem ipsum dolor sit amet..”来源于1.10.32节中的一行。',
      why_do_we_use_it: '我们为什么使用它？',
      last_para:
        '长期以来，人们认为当看到页面布局时，读者会被页面的可读内容所分散注意力。使用Lorem Ipsum的目的在于它具有更或多或少正常分布的字母，而不是使用“这里的内容，这里的内容”，使其看起来像可读的英语。许多桌面出版包和网页编辑器现在将Lorem Ipsum作为其默认的模型文本，并且搜索“lorem ipsum”将揭示许多仍处于初始阶段的网站。多年来，各种版本不经意间或有意（注入的幽默等）演变。',
    },
  },
  cms: {
    appearance: '外观',
    location: '位置',
    profile: '个人资料',
    seo: '搜索引擎优化',
    page: '页面',
    account: '账户',
    security: '安全性',
    billings: '账单',
    custom_image: '自定义图片',
    maximum: '最大值',
    choose_another: '选择其他',
    select_font: '选择字体',
    rounded_corners: '圆角',
    circle: '圆形',
    full_rounded_corners: '完整的圆角',
    straight_corners: '直角',
    outline: '轮廓',
    button_background_color: '按钮背景颜色',
    timer_digit_color: '计时器数字颜色',
    timer_background_color: '计时器背景颜色',
    button_font_color: '按钮字体颜色',
    outline_style: '轮廓样式',
    outline_width: '轮廓宽度',
    corners: '角',
    insert_graph_image: '插入图像',
    enble_block_search_engine_indexing: '启用阻止搜索引擎索引',
    page_title_required: '需要页面标题',
    meta_description_required: '需要元描述',
    branding_url_required: '需要品牌网址',
    enter_title: '输入标题',
    enter_url: '输入网址',
    enter_meta_description: '输入元描述',
    enter_page_title: '输入页面标题',
    enter_alt_text: '输入ALT文本',
    hours: '小时',
    minutes: '分钟',
    seconds: '秒',
    scan_qr_code: '扫描二维码',
    cancel: '取消',
    you_sure_want_to_logout: '您确定要退出吗？',
    previous: '上一页',
    next: '下一页',
  },
  appearance: {
    background_cap: '背景',
    background: '背景',
    favicon_cap: '网站图标',
    favicon: '网站图标',
    fonts_cap: '字体',
    fonts: '字体',
    seo_cap: '搜索引擎优化',
    seo: '搜索引擎优化',
    avatar_cap: '头像',
    avatar: '头像',
    link_cap: '链接',
    link: '链接',
    branding_cap: '品牌',
    branding: '品牌',
  },
  contact: {
    name_required: '姓名为必填项',
    only_alphabets: '此字段仅允许字母',
    more_characters: '姓名不能超过20个字符。',
    valid: '电子邮件必须是有效的',
    subject: '主题为必填项',
    subject_max: '主题不能超过30个字符。',
    message: '消息为必填项',
    message_min: '最小消息长度必须为40个字符。',
    message_max: '消息不能超过250个字符。',
  },

  descriptions: {
    shorten_urls:
      '利用各种在线平台与志同道合的人互动，获得曝光，并为您的创意努力建立数字存在，所有这些都可以通过您的一个生物链接完成。',
    fully_featured: '功能齐全的QR码生成系统，具有易于使用的模板。',
    update_checkout: '更新并继续黄金结账',
    plans_management: '计划管理',
    create_plan: '创建计划',
    no_account: '没有帐户？',
    leave_empty: '留空以生成随机生成的内容。',
    scan_qr:
      '如果要激活两因素身份验证，请扫描QR码或在Google Authenticator应用中输入秘密密钥并输入OTP。',
    skip: '或跳过',
    copy_Qr: '复制秘密密钥，它是机密的。',
    scanned: '检查您的电子邮件或Google Authenticator中的代码。',
    do_everything: '做一切',
    with_one: '用一个',
    platform: '平台',
    get_started: '开始吧',
    create_own: '轻松创建您自己独特且高度可定制的生物链接页面。',
    custom_colors: '自定义颜色和品牌',
    ready_to_use: '多个即用组件',
    protection: '密码保护，敏感内容警告',
    seo_setting: 'SEO设置',
    shortened_links: '缩短链接',
    service: '是的！您也可以将我们的服务用作缩短工具。',
    demographic: '国家、设备和语言定位',
    scheduling: '计划和到期限制',
    ab_rotation: 'A/B旋转',
    password: '密码保护，敏感内容警告',
    built_in: '内置分析',
    generate_links:
      '生成动态链接到文件，并从跟踪、保护、像素和到期功能中受益。',
    generate_vcard:
      '生成动态vcard链接到您的联系下载卡，并从跟踪、保护、像素和到期功能中受益。',
    day_by: '用于每日分析、推荐、国家、操作系统、语言等。',
    connect: '连接您自己的域名或使用我们预定义的域名。',
    easiest_way: '将托管资源分类的最简单方式。',
    offering: '我们还为您提供一套35个有用的Web工具作为奖励。',
    choose_yourself: '选择并获得您所需的东西。',
    feel_free: '随时与我们联系',
    enter_message: '在此输入您的消息。',
    add_multiple_images: '添加多个图片',
    add_link: '添加链接按钮',
    add_new: '添加新块',
    add_heading: '添加标题',
    add_avatar: '添加头像',
    add_social: '添加社交链接',
    choose_custom_plan: '开始黄金计划',
    almost_there: '您差不多了，没有附加条件。',
    trial_start: '开始我的7天试用',
    skip_trial: '跳过试用',
    trial_info: '继续您的订单，确认您阅读、理解并同意本站的',
    terms: '条款和条件',
    add_image: '添加图像',
    img_description: '图像描述，以实现可访问性和SEO目的。',
    add_youtube: '添加YouTube视频',
    paste_video_url: '粘贴您的YouTube视频URL，我们将在您的个人资料上显示它。',
    add_tiktok: '添加TikTok视频',
    tiktok_url: 'TikTok视频URL',
    valid_email: '电子邮件必须是有效的电子邮件地址',
    distination_Url: '目标URL',
    email_required: '电子邮件是必需的',
    password_required: '需要密码',
    name_required: '需要姓名',
    user_name_required: '需要用户名',
    firstName_required: '需要名字',
    firstName_must_alphabets: '名字必须只包含字母。',
    lastName_must_alphabets: '姓氏必须只包含字母。',
    enter_email:
      '请输入与您的帐户关联的电子邮件地址，我们将给您发送一个链接，以重置您的密码。',
    already_account: '已经有一个帐户？',
    paste_tiktok: '分享您的TikTok视频URL',

    drag_drop: '拖放以重新排序',
    can_confirm: '我确认我已阅读并了解',
    of_site: '本站的',
    confirm_password: '确认新密码',
    confirm_new: '需要确认密码',
    field_required: '字段是必需的',
    add_instagram: '添加Instagram帖子',
    entered_url: '您输入的URL无效以嵌入',
    least_characters: '密码必须至少为6个字符',
    must_match: '密码必须匹配',
    check_email: '请检查您的电子邮件！',
    sent_code:
      '我们已经向acb@domain发送了一个6位数的确认代码，请在下面的框中输入代码以验证您的电子邮件。',
    no_code: '没有代码？',
    code_required: '代码是必需的',
    checking_email: '检查用户电子邮件',
    monthly_payment: '每月付款',
    golden_plan: '黄金计划',
    plan_detail: '您差不多了，请完成以下表单并结账。',
    payment_frequency: '付款频率',
    annual_payments: '年度付款',
    lifetime_deal: '终身交易',
    payment_method: '支付方式',
    payment_method_stripe: '通过Stripe支付',
    type_payment: '付款类型',
    stripe: '条纹',
    one_payment: '一次性付款',
    recurring_payment: '定期付款',
    order_summary: '订单摘要',
    plan: '计划',
    golden: '黄金',
    frequency: '频率',
    monthly: '每月',
    type: '类型',
    one_time: '一次性',
    paid_with: '支付方式',
    pay_pal: 'PayPal',
    price: '价格',
    code_redeemable: '我有折扣/可兑换代码',
    code: '代码',
    total: '总计',
    checkout: '结账',
    day: '每30天',
    billing: '账单',
    choosen_plan: '选择的计划',
    home: '主页',
    what_get: '您将获得什么',
    one_product: '一个最终产品',
    month_update: '12个月更新',
    month_support: '6个月支持',
    bio_pages: '25个Biolink页面',
    bio_block: '10个Biolink块',
    all_block: '所有Biolink块',
    short_link: '250个缩短链接',
    file_link: '2个文件链接',
    vcard_link: '2个Vcard链接',
    qr_code: '5个QR码',
    proj: '50个项目',
    pixel: '5个像素',
    custom_domain: '自定义域名',
    day_stat: '365天统计数据保留',
    global_domain: '额外的全球域',
    back_half: '自定义后半部分',
    deep_lnk: '深度链接',
    removable_brand: '可移动品牌',
    custom_back: '自定义背景',
    custom_col: '自定义颜色',
    defollow: 'Dofollow链接',
    leap_link: 'Leap链接',
    seo_feature: 'SEO功能',
    extra_font: '额外的字体',
    add_tweet: '添加推文',
    custome_css: '自定义CSS',
    custom_js: '自定义JS',
    no_ad: '没有广告',
    api_access: 'API访问',
    fill: '填写您的账单详细信息',
    handling:
      '我们需要您的账单详细信息以生成适当的发票和进行税务处理，仅提供有效的账单详细信息。',
    user_manag: '用户管理',
    user_logs: '用户日志',
    user_creat: '创建用户',
    set_2fa: '设置两因素身份验证',
    user: '用户',
    showout_result: '显示结果',
    status: '状态',
    applied_codes: '应用代码',
    applied_taxes: '应用税收',
    detail: '详情',
    bulk_actions: '批量操作',
    hidden_demo: '在演示中隐藏',
    cant_undone: '无法撤消。',
    login_thisuser: '以此用户身份登录',
    loginmodal_detail1: '通过以其他用户身份登录，您将注销',
    loginmodal_detail2: '当前帐户，并完全登录到此用户。',
    show_result: '显示12个结果中的1-12个。',
    total_sales: '总销售额',
    visitors: '访客',
    page_views: '页面浏览量',
    paste_instagram_url: '粘贴Instagram帖子的URL',
    delete_block_des: '与Biolink块相关的所有数据将被完全删除。此操作无法撤消。',
    duplicate_block_des: '只需点击按钮即可轻松复制此资源。',
    delete_block: '删除块',
    duplicate_block: '复制块',
    total_amount: '总金额',
    admin_privileges: '管理员用户将拥有与您相同的权限，务必小心！',
    change_passDetail: '如果不想更改用户的密码，请将其留空！',
    new_pass: '新密码',
    repeat_pass: '重复密码',
    block_search: '阻止搜索引擎索引块',
    block_biolink: '阻止搜索引擎索引您的生物链接页面。',
    change_page: '完全更改页面标题为您在此处设置的自定义标题。',
    custom_meta:
      '为您的生物链接页面设置自定义meta描述，以在搜索引擎中更好地排名。',
  },

  admin: {
    welcome: '欢迎回来',
    biolink_pages: '生物链接页面',
    pageviews_tracked: '跟踪的页面浏览量',
  },

  label: {
    view_user: '查看用户',
    privileges: '特权',
    timezone: '时区',
    Factor_authentication: '两因素身份验证',
    Factor_authentication_2: '2因素身份验证',
    Anti_code: '反钓鱼代码',
    active: '激活',
    english: '英语',
    no: '否',
    api_key: 'API密钥',
    total_logins: '总登录次数',
    last_useragent: '最后的用户代理',
    last_active: '最后活动',
    country: '国家',
    direct_signup: '直接注册',
    source: '来源',
    trial_done: '试用已完成',
    last_subid: '最后的订阅ID',
    last_payamount: '最后的付款金额',
    last_payprocessor: '最后的支付处理器',
    plan_expdate: '计划到期日期',
    free: '免费',
    disabled: '禁用',
    hidden: '隐藏',
    arabic: '阿拉伯语',
    main_language: '主要语言',
    add_tweet: '添加推文',
    update: '更新',
    change_password: '更改密码',
    enable_stripepay: '启用Stripe支付',
    publishable_key: '可发布密钥',
    secret_key: '秘密密钥',
    webhook_secret: 'Webhook密钥',
    webhook: 'Webhook',
    more_detail: '获取有关某些可用配置的更多详细信息。',
    read_the: '阅读',
    documentation: '文档',
  },

  addBlock: {
    essentials: '基本',
    text: '文本',
    media: '媒体',
    miscellaneous: '杂项',
    addBlocks: '添加块',
    viewBlock: '查看块',
    paymentDetails: '付款详情',
    renewal: '续订',
    inclusive_tax: '含税',
    apply: '应用',
    plan: '计划',
    enter_coupon_code: '输入优惠券代码',
    set_up_your: '设置您的',
    credit_debit_card: '信用卡/借记卡',
    card_number: '卡号',
    card_number_is_required: '卡号是必填项',
    please_enter_valid_card_number: '请输入有效的卡号',
    please_enter_valid_cvv_number: '请输入有效的CVV',
    expiry_date_is_required: '到期日期是必填项',
    expiry_date: '到期日期',
    enter_valid_month: '输入有效的月份',
    enter_valid_year: '输入有效的年份',
    expiry_date_valid_month_year: '输入有效的到期日期',
    cvv_is_required: 'CVV是必填项',
    invalid_characters_in_name: '姓名中包含无效字符',
    change: '更改',
    renew_plan_automatically: '自动在每个月底续订计划，随时取消。',
    make_payment: '进行支付',
    subscribe_start_customizing: '订阅并开始自定义',
    your_biolink_now: '您的Biolink NOW！',
    year: '年',
    month: '月',
    annual: '年度',
    off: '折扣',
    auto: '自动',
    payment_successful: '付款成功',
    enjoy: '享受',
    using_premium_and_continue: '使用Premium并继续创建',
    exclusive_biolinks: '独特的Biolinks',
    page: '页面',
    account: '账户',
    account_: '账户',
    security: '安全',
    billings: '账单',
    setting: '设置',
    page_name: '页面名称',
    update_your_page_name: '更新您的页面名称以创建独特的身份。',
    save_changes: '保存更改',
    page_name_cannot: '页面名称不能包含符号',
    remove: '删除',
    personal_details: '个人详细信息',
    first_name_must_be_valid: '名字必须是有效的名字',
    first_name_must_be_20_characters: '名字最多应为20个字符',
    email_should_be_50_characters: '电子邮件应最多为50个字符',
    email_address_must_be_valid: '电子邮件地址必须是有效的地址',
    upload: '上传',
    choose_account_type: '选择账户类型',
    enter_country: '输入国家',
    state_region: '州/地区',
    enter_state_region: '输入州/地区',
    enter_city: '输入城市',
    zip_code: '邮政编码',
    enter_zip_code: '输入邮政编码',
    account_type_required: '需要账户类型',
    country_required: '需要国家',
    State_region_required: '需要州/地区',
    city_required: '需要城市',
    zip_required: '需要邮政编码',
    image_smaller_than_3MB: '图像必须小于3MB',
    please_select_picture: '请选择图片',
    image_size_should_be_3mb: '图像大小不得超过3MB。允许的文件为.jpeg和.png。',
    security_: '安全',
    enter_password_twice: '两次输入新密码以更改密码',
    new_password: '新密码',
    password_must_8_characters: '密码必须至少包含8个字符',
    including_uppercase_letter:
      '包括1个大写字母，1个小写字母，1个特殊字符和1个数字值',
    enter_new_password: '输入新密码',
    confirm_password: '确认密码',
    password_confirmation_required: '需要确认密码',
    passwords_not_match: '密码不匹配',
    enter_confirm_password: '输入确认密码',
    factor_authentication_description:
      '如果要激活两因素身份验证，请扫描QR码或在Google Authenticator应用中输入密钥并输入OTP',
    choose_plan_description: '选择适合您要求的计划',
    billing_history: '账单历史',
    date_joined: '加入日期',
    last_activity: '最后活动',
    annually: '每年',
    header: '标题',
    add_header: '添加标题',
    enter_page_name: '输入页面名称',
    enter_page_title: '输入页面标题',
    pagename_required: '页面名称必填',
    pagetitle_required: '页面标题必填',
    contact_required: '联系方式必填',
    edit_header: '编辑标题',
    whatapp_required: "需要Whatsapp",
    whatapp: "Whatsapp",
    profile_alignment: "轮廓对齐",
    left: "左边",
    center: "中心",
    right: "正确的",
    want_to_set_background_image: "想要设置背景图像",
    avatar_size: "头像尺寸",
    avatar_shape: "头像形状",
    avatar_outline: "头像轮廓",
  },
  enter: '输入',
  media: '媒体',
  link_URL_must_start: '链接URL必须以http://或https://开头',
  link_icon_required: '需要链接图标',
  link_url_required: '链接URL是必填项',
  link_is_required: '链接标题是必填项',
  add_icon: '添加图标',
  enter_link: '输入链接',
  enter_link_title: '输入链接标题',
  custom_link: '自定义链接',
  add_image_grid: '添加图像网格',
  header_required: '需要标题',
  enter_header: '输入标题',
  header_size: '标题大小',
  header_: '标题',
  question_required: '需要问题',
  answer_required: '需要答案',
  enter_question: '输入问题',
  enter_answer: '输入答案',
  choose_time: '选择时间',
  choose_date: '选择日期',
  drop_your_img: '将您的图像拖到此处或',
  browse_image: '浏览图像',
  save: '保存',
  components: '组件',
  payments: '付款',
  terms_here: '您的服务条款在此处',
  bold: '加粗',
  user_id: '用户ID',
  italic: '斜体',
  underline: '下划线',
  changelog_config: '确保重新配置您的计划设置以适应新的附加域配置',
  initial_release: '初始版本发布',
  changelog_detail:
    '所有Bil Bio的更新都将在此处列出。Bil Bio的版本控制基于MAJOR.MINOR.PATCH系统',
  get_support: '获取支持',
  support_is: '支持是',
  only: '仅',
  done_codecanyon: '通过Codecanyon的',
  email_form: '电子邮件表单',
  comments: '评论',
  section: '部分',
  changelog: '更新日志',
  edit_home: '编辑主页',
  home_settings: '主页设置',
  docs: '文档',
  read_documentation: '阅读文档',
  read_changelog: '阅读更新日志',
  latest_users: '最新用户',
  page_views: '页面浏览量',
  biolinks_pages: 'Biolinks页面',
  authenticate: '身份验证',
  auth_type: '身份验证类型',
  time_based: '基于时间',
  secret_key: '秘密密钥',
  availabe_plan: '计划可用的天数',
  code_usage: '代码可用次数',
  percent_disc: '百分比折扣',
  fix_discount: '固定金额折扣',
  discount_amount: '折扣金额',
  percent_amount: '百分比金额',
  duration: '持续时间',
  once: '一次',
  forever: '永远',
  repeating: '重复',
  number_ofmonths: '月数',
  months: '个月',
  currency: '货币',
  redeemable: '可兑换的',
  install_product: '如何安装该产品？',
  update_product: '如何更新该产品？',
  customize_product: '如何定制该产品？',
  meta_description: '元描述',
  title: '标题',
  statistics: '统计',
  opengraph_image: 'OpenGraph 图片',
  page_title: '页面标题',
  countdown: '倒计时',
  personal: '个人',
  business: '商业',
  city: '城市',
  country: '国家',
  province: '省份',
  zip: '邮政编码',
  resend_code: '重新发送代码',
  yes: '是',
  choose_plan: '选择计划',
  choose_plan_cap: '选择计划',
  home: '主页',
  social: '社交',
  whatYouWillGet: '你将获得什么',
  and: '和',
  links_statistics: '链接统计',
  oftheSite: '网站',
  link: '链接',
  link_cap: '链接',
  telephone: '电话',
  register: '注册',
  facebook: 'Facebook',
  google: 'Google',
  tracking_pixels: '跟踪像素',
  tool: '工具',
  block: '块',
  instagram: 'Instagram',
  twitter: 'Twitter',
  username: '用户名',
  add: '添加',
  add_cap: '添加',
  short_url: '短链接',
  customization: '定制',
  channel: '频道',
  branding: '品牌',
  fonts: '字体',
  submit: '提交',
  tracked_reviews: '追踪的页面浏览量',
  delete: '删除',
  duplicate: '复制',
  monochrome: '单色',
  gradient: '渐变',
  custom: '自定义',
  themes: '主题',
  background: '背景',
  simple_gradients: '简单渐变',
  abstract_gradients: '抽象渐变',
  custom_color: '自定义颜色',
  faq: '常见问题解答',
  color: '颜色',
  colors: '颜色',
  custom_image_video: '自定义图像/视频',
  favicon: 'Favicon',
  share: '分享',
  image_alt: '图像替代文本',
  maximum: '允许 .png, .gif, .ico 格式，最大2 MB。',
  display: '显示',
  total_earned: '总收入',
  name: '名字',
  Unique_user_name: '唯一用户名',
  firstName: '名字',
  text_color: '文本颜色',
  default_branding: '留空使用默认网站品牌',
  size: '尺寸',
  shape: '形状',
  instagram_url: 'Instagram 帖子链接',
  border_radius: '边框半径',
  youtube_url: 'YouTube 视频链接',
  total: '总数',
  biolinks: 'Biolinks',
  biolink: 'Biolink',
  files: '文件',
  file: '文件',
  biolink_blocks: 'Biolink 块',
  card: '卡片',
  destination_url: '目标链接',
  codes: '代码',
  domains: '域名',
  create: '创建税收',
  links: '链接',
  copyright: '版权',
  terms_of_service: '服务条款',
  views: '浏览量',
  privacy_policy: '隐私政策',
  overview: '概览',
  needed_docs: '在此页面，您可以找到产品的所需文档，以便您完全安装和配置产品。',
  product_installation:
    '产品安装过程直截了当，不需要任何特殊/非寻常的任务，只需要基本的数据库和服务器文件管理知识。',
  policy_here: '您的隐私政策在此。',
  requirements: '需求',
  meet_req: '在尝试安装或购买产品之前，请确保您的服务器满足以下要求。',
  created_on: '创建于 ',
  extensions: '扩展',
  database: '数据库',
  server: '服务器',
  other_extentions:
    '请注意，除了这里提到的扩展之外，可能还需要其他扩展。这些要求假设您在运行一个体面、最新的服务器上，该服务器应该已经具备基本所需的扩展。',
  find_me: '我制作高质量、现成可用且价格合理的软件。您可以在以下位置找到我：',
  december: '十二月',
  twitter_bilBio: 'Twitter @BilBio',
  official_website: '官方网站',
  who_are_we: '我们是谁？',
  all_rights_reserved: '保留所有权利',
  export_to: '导出到',
  filter: '过滤器',
  search: '搜索',
  search_by: '按...搜索',
  status: '状态',
  project: '项目',
  type: '类型',
  order_type: '订单类型',
  results_per_page: '每页结果',
  your_custom_alias: '您的自定义别名',
  mode: '模式',
  contrast: '对比度',
  direction: '方向',
  layout: '布局',
  presets: '预设',
  stretch: '拉伸',
  fullscreen: '全屏',
  exit: '退出',
  pricing_plans: '价格计划',
  monthly: '月付',
  annual: '年付',
  life_time: '终身',
  address: '地址',
  phone: '电话',
  send_message: '发送消息',
  email: '电子邮件',
  subject: '主题',
  heading: '标题',
  text_editor: '文本编辑器',
  avatar: '头像',
  socials: '社交媒体',
  linkedin: 'LinkedIn',
  snapchat: 'SnapChat',
  twitch: 'Twitch',
  spotify: 'Spotify',
  image: '图像',
  pinterest: '脱贫网',
  youtube: '油管',
  tiktok: '抖音',
  about_section: '关于页面设置',
  contact_settings: '联系设置',
  Biolink_Page: 'Biolink 页面',
  Qr_code: 'QR 码',
  analytics: '内置分析',
  destination: '目的地',
  purchased_Plan_monthly: '您已购买了一个月付计划。',
  purchased_Plan_yearly: '您已购买了一个年付计划。',
  purchased_Plan_lifetime: '您已购买了一个终身计划。',
  enjoy_your_plan: '请享受您的终身计划。',
  close: '关闭',
  want_to_update_plan_yearly_lifetime: '您想更新您的计划为年付还是终身？',
  want_to_update_plan_lifetime: '您想更新您的终身计划吗？',
  updating_plan: '更新计划',
  powered_by: '由...提供动力',
  text: '文本',
  round: '圆形',
  rounded: '圆角',
  straight: '直角',
  solid: '实线',
  dashed: '虚线',
  double: '双线',
  outset: '外凸',
  inset: '内凹',
  border_width: '边框宽度',
  border_color: '边框颜色',
  border_style: '边框样式',
  infinite: '无限',
  bg_color: '背景颜色',
  animation: '动画',
  animation_runs: '动画运行',
  bounce: '弹跳',
  tada: 'TaDa',
  wobble: '摇晃',
  swing: '摆动',
  rubberband: '橡皮筋',
  pulse: '脉动',
  flash: '闪光',
  bounce_in: 'BounceIn',
  fade_in: 'FadeIn',
  small: '小',
  medium: '中',
  large: '大',
  img_thumbnail: '图像缩略图',
  email_address: '电子邮件地址',
  pass: '密码',
  forgot_password: '忘记密码？',
  forgot_desc: '别担心！这种情况是常有的。',
  forgot_description: '请输入与您的账户关联的电子邮件地址。',
  login: '登录',
  remember_me: '记住我',
  send_request: '发送请求',
  back: '返回',
  dashboard: '仪表板',
  plans: '计划',
  taxes: '税收',
  website_settings: '网站设置',
  languages: '语言',
  language_code: '语言代码',
  verify: '验证',
  tweet_id: '推特ID',
  divider: '分隔线',
  add_divider: '添加分隔线',
  seo: '搜索引擎优化',
  image_grid: '图像网格',
  codes_management: '代码管理',
  create_tax: '创建税收',
  redeemed: '已兑换',
  quantity: '数量',
  discount: '折扣',
  tax: '税收',
  billing_for: '账单用途',
  taxes_management: '税收管理',
  random_discription: '一个用于支持费的随机描述。',
  personal_business: '个人与商业',
  exclusive: '独家',
  support_fee: '支持费',
  call_to_action: '呼叫行动',
  language: '语言',
  users: '用户',
  add_plan: '添加计划',
  interval_count: '间隔计数',
  interval: '间隔',
  trial_days: '试用天数',
  year: '年',
  month: '月',
  create_code: '创建代码',
  create_newCode: '创建新代码',
  countries: {
    afghanistan: '🇦🇫 阿富汗',
    aland_islands: '🇦🇽 奥兰群岛',
    albania: '🇦🇱 阿尔巴尼亚',
    algeria: '🇩🇿 阿尔及利亚',
    american_samoa: '🇦🇸 美属萨摩亚',
    andorra: '🇦🇩 安道尔',
    angola: '🇦🇴 安哥拉',
    anguilla: '🇦🇮 安圭拉',
    antarctica: '🇦🇶 南极洲',
    antigua_barbuda: '🇦🇬 安提瓜和巴布达',
    argentina: '🇦🇷 阿根廷',
    armenia: '🇦🇲 亚美尼亚',
    aruba: '🇦🇼 阿鲁巴',
    australia: '🇦🇺 澳大利亚',
    austria: '🇦🇹 奥地利',
    azerbaijan: '🇦🇿 阿塞拜疆',
    bahamas: '🇧🇸 巴哈马',
    bahrain: '🇧🇭 巴林',
    bangladesh: '🇧🇩 孟加拉国',
    barbados: '🇧🇧 巴巴多斯',
    belarus: '🇧🇾 白俄罗斯',
    belgium: '🇧🇪 比利时',
    belize: '🇧🇿 伯利兹',
    benin: '🇧🇯 贝宁',
    bermuda: '🇧🇲 百慕大',
    bhutan: '🇧🇹 不丹',
    bolivia: '🇧🇴 玻利维亚',
    eustatius_saba: '🇧🇶 博内尔，圣尤斯特歇斯和萨巴',
    bosnia_herzegovina: '🇧🇦 波斯尼亚和黑塞哥维那',
    botswana: '🇧🇼 博茨瓦纳',
    bouvet_island: '🇧🇻 布韦岛',
    brazil: '🇧🇷 巴西',
    british_indian: '🇮🇴 英属印度洋领地',
    brunei_darussalam: '🇧🇳 文莱达鲁萨兰国',
    bulgaria: '🇧🇬 保加利亚',
    burkina_faso: '🇧🇫 布基纳法索',
    burundi: '🇧🇮 布隆迪',
    cambodia: '🇰🇭 柬埔寨',
    cameroon: '🇨🇲 喀麦隆',
    canada: '🇨🇦 加拿大',
    cape_verde: '🇨🇻 佛得角',
    cayman_islands: '🇰🇾 开曼群岛',
    central_african: '🇨🇫 中非共和国',
    chad: '🇹🇩 乍得',
    chile: '🇨🇱 智利',
    china: '🇨🇳 中国',
    christmas_island: '🇨🇽 圣诞岛',
    cocos_islands: '🇨🇨 科科斯（基林）群岛',
    colombia: '🇨🇴 哥伦比亚',
    comoros: '🇰🇲 科摩罗',
    congo: '🇨🇬 刚果',
    democratic_republic: '🇨🇩 刚果民主共和国',
    cook_islands: '🇨🇰 库克群岛',
    costa_rica: '🇨🇷 哥斯达黎加',
    cote_ivoire: '🇨🇮 科特迪瓦',
    croatia: '🇭🇷 克罗地亚',
    cuba: '🇨🇺 古巴',
    curacao: '🇨🇼 库拉索',
    cyprus: '🇨🇾 塞浦路斯',
    czech_republic: '🇨🇿 捷克共和国',
    denmark: '🇩🇰 丹麦',
    djibouti: '🇩🇯 吉布提',
    dominica: '🇩🇲 多米尼克',
    dominican_republic: '🇩🇴 多米尼加共和国',
    ecuador: '🇪🇨 厄瓜多尔',
    egypt: '🇪🇬 埃及',
    el_salvador: '🇸🇻 萨尔瓦多',
    equatorial_guinea: '🇬🇶 赤道几内亚',
    eritrea: '🇪🇷 厄立特里亚',
    estonia: '🇪🇪 爱沙尼亚',
    ethiopia: '🇪🇹 埃塞俄比亚',
    falkland_islands: '🇫🇰 福克兰群岛（马尔维纳斯）',
    faroe_islands: '🇫🇴 法罗群岛',
    fiji: '🇫🇯 斐济',
    finland: '🇫🇮 芬兰',
    france: '🇫🇷 法国',
    french_guiana: '🇬🇫 法属圭亚那',
    french_polynesia: '🇵🇫 法属波利尼西亚',
    southern_territories: '🇹🇫 法属南部领地',
    gabon: '🇬🇦 加蓬',
    gambia: '🇬🇲 冈比亚',
    georgia: '🇬🇪 格鲁吉亚',
    germany: '🇩🇪 德国',
    ghana: '🇬🇭 加纳',
    gibraltar: '🇬🇮 直布罗陀',
    greece: '🇬🇷 希腊',
    greenland: '🇬🇱 格陵兰',
    grenada: '🇬🇩 格林纳达',
    guadeloupe: '🇬🇵 瓜德罗普',
    guam: '🇬🇺 关岛',
    guatemala: '🇬🇹 危地马拉',
    guernsey: '🇬🇬 根西岛',
    guinea: '🇬🇳 几内亚',
    guinea_bissau: '🇬🇼 几内亚比绍',
    guyana: '🇬🇾 圭亚那',
    haiti: '🇭🇹 海地',
    heard_island: '🇭🇲 赫德岛和麦克唐纳群岛',
    holy_see: '🇻🇦 教廷（梵蒂冈城国）',
    honduras: '🇭🇳 洪都拉斯',
    hong_kong: '🇭🇰 香港',
    hungary: '🇭🇺 匈牙利',
    iceland: '🇮🇸 冰岛',
    india: '🇮🇳 印度',
    indonesia: '🇮🇩 印度尼西亚',
    iran_islamic: '🇮🇷 伊朗，伊斯兰共和国',
    iraq: '🇮🇶 伊拉克',
    ireland: '🇮🇪 爱尔兰',
    isle_man: '🇮🇲 曼岛',
    israel: '🇮🇱 以色列',
    italy: '🇮🇹 意大利',
    jamaica: '🇯🇲 牙买加',
    japan: '🇯🇵 日本',
    jersey: '🇯🇪 泽西岛',
    jordan: '🇯🇴 约旦',
    kazakhstan: '🇰🇿 哈萨克斯坦',
    kenya: '🇰🇪 肯尼亚',
    kiribati: '🇰🇮 基里巴斯',
    korea_democratic: '🇰🇵 朝鲜民主主义人民共和国',
    korea_republic: '🇰🇷 韩国',
    kosovo: '🇽🇰 科索沃',
    kuwait: '🇰🇼 科威特',
    kyrgyzstan: '🇰🇬 吉尔吉斯斯坦',
    lao_people: '🇱🇦 老挝人民民主共和国',
    latvia: '🇱🇻 拉脱维亚',
    lebanon: '🇱🇧 黎巴嫩',
    lesotho: '🇱🇸 莱索托',
    liberia: '🇱🇷 利比里亚',
    libyan_arab: '🇱🇾 利比亚阿拉伯',
    liechtenstein: '🇱🇮 列支敦士登',
    lithuania: '🇱🇹 立陶宛',
    luxembourg: '🇱🇺 卢森堡',
    macao: '🇲🇴 澳门',
    macedonia_former: '🇲🇰 前南斯拉夫马其顿共和国',
    madagascar: '🇲🇬 马达加斯加',
    malawi: '🇲🇼 马拉维',
    malaysia: '🇲🇾 马来西亚',
    maldives: '🇲🇻 马尔代夫',
    mali: '🇲🇱 马里',
    malta: '🇲🇹 马耳他',
    marshall_islands: '🇲🇭 马绍尔群岛',
    martinique: '🇲🇶 马提尼克',
    mauritania: '🇲🇷 毛里塔尼亚',
    mauritius: '🇲🇺 毛里求斯',
    mayotte: '🇾🇹 马约特',
    mexico: '🇲🇽 墨西哥',
    micronesia_federated: '🇫🇲 密克罗尼西亚联邦',
    moldova_republic: '🇲🇩 摩尔多瓦共和国',
    monaco: '🇲🇨 摩纳哥',
    mongolia: '🇲🇳 蒙古',
    montenegro: '🇲🇪 黑山',
    montserrat: '🇲🇸 蒙特塞拉特',
    morocco: '🇲🇦 摩洛哥',
    mozambique: '🇲🇿 莫桑比克',
    myanmar: '🇲🇲 缅甸',
    namibia: '🇳🇦 纳米比亚',
    nauru: '🇳🇷 瑙鲁',
    nepal: '🇳🇵 尼泊尔',
    netherlands: '🇳🇱 荷兰',
    netherlands_antilles: '🇦🇳 荷属安的列斯群岛',
    new_caledonia: '🇳🇨 新喀里多尼亚',
    new_zealand: '🇳🇿 新西兰',
    nicaragua: '🇳🇮 尼加拉瓜',
    niger: '🇳🇪 尼日尔',
    nigeria: '🇳🇬 尼日利亚',
    niue: '🇳🇺 纽埃',
    norfolk_island: '🇳🇫 诺福克岛',
    northern_mariana: '🇲🇵 北马里亚纳群岛',
    norway: '🇳🇴 挪威',
    oman: '🇴🇲 阿曼',
    pakistan: '🇵🇰 巴基斯坦',
    palau: '🇵🇼 帕劳',
    palestinian_territory: '🇵🇸 巴勒斯坦领土',
    panama: '🇵🇦 巴拿马',
    papua_new: '🇵🇬 巴布亚新几内亚',
    paraguay: '🇵🇾 巴拉圭',
    peru: '🇵🇪 秘鲁',
    philippines: '🇵🇭 菲律宾',
    pitcairn: '🇵🇳 皮特凯恩群岛',
    poland: '🇵🇱 波兰',
    portugal: '🇵🇹 葡萄牙',
    puerto_rico: '🇵🇷 波多黎各',
    qatar: '🇶🇦 卡塔尔',
    reunion: '🇷🇪 留尼汪',
    romania: '🇷🇴 罗马尼亚',
    russian_federation: '🇷🇺 俄罗斯联邦',
    rwanda: '🇷🇼 卢旺达',
    saint_barthelemy: '🇧🇱 圣巴泰勒米',
    saint_helena: '🇸🇭 圣赫勒拿',
    saint_kitts: '🇰🇳 圣基茨和尼维斯',
    saint_lucia: '🇱🇨 圣卢西亚',
    saint_martin: '🇲🇫 圣马丁',
    saint_pierre: '🇵🇲 圣皮埃尔和密克隆',
    saint_vincent: '🇻🇨 圣文森特和格林纳丁斯',
    samoa: '🇼🇸 萨摩亚',
    san_marino: '🇸🇲 圣马力诺',
    sao_tome: '🇸🇹 圣多美和普林西比',
    saudi_arabia: '🇸🇦 沙特阿拉伯',
    senegal: '🇸🇳 塞内加尔',
    serbia: '🇷🇸 塞尔维亚',
    serbia_montenegro: '🇨🇸 塞尔维亚和黑山',
    seychelles: '🇸🇨 塞舌尔',
    sierra_leone: '🇸🇱 塞拉利昂',
    singapore: '🇸🇬 新加坡',
    sint_maarten: '🇸🇽 圣马丁',
    slovakia: '🇸🇰 斯洛伐克',
    slovenia: '🇸🇮 斯洛文尼亚',
    solomon_islands: '🇸🇧 所罗门群岛',
    somalia: '🇸🇴 索马里',
    south_africa: '🇿🇦 南非',
    south_georgia: '🇬🇸 南乔治亚岛和南桑威奇群岛',
    south_sudan: '🇸🇸 南苏丹',
    spain: '🇪🇸 西班牙',
    sri_lanka: '🇱🇰 斯里兰卡',
    sudan: '🇸🇩 苏丹',
    suriname: '🇸🇷 苏里南',
    svalbard_jan: '🇸🇯 斯瓦尔巴和扬马延',
    swaziland: '🇸🇿 斯威士兰',
    sweden: '🇸🇪 瑞典',
    switzerland: '🇨🇭 瑞士',
    syrian_arab: '🇸🇾 叙利亚阿拉伯共和国',
    taiwan_province: '🇹🇼 台湾，省份，中国',
    tajikistan: '🇹🇯 塔吉克斯坦',
    tanzania_united: '🇹🇿 坦桑尼亚，联合共和国',
    thailand: '🇹🇭 泰国',
    timor_leste: '🇹🇱 东帝汶',
    togo: '🇹🇬 多哥',
    tokelau: '🇹🇰 托克劳',
    tonga: '🇹🇴 汤加',
    trinidad_tobago: '🇹🇹 特立尼达和多巴哥',
    tunisia: '🇹🇳 突尼斯',
    turkey: '🇹🇷 土耳其',
    turkmenistan: '🇹🇲 土库曼斯坦',
    turks_caicos: '🇹🇨 特克斯和凯科斯群岛',
    tuvalu: '🇹🇻 图瓦卢',
    uganda: '🇺🇬 乌干达',
    ukraine: '🇺🇦 乌克兰',
    united_arab: '🇦🇪 阿拉伯联合酋长国',
    united_kingdom: '🇬🇧 英国',
    united_states: '🇺🇸 美国',
    unitedStates_minor: '🇺🇲 美国本土外小岛屿',
    uruguay: '🇺🇾 乌拉圭',
    uzbekistan: '🇺🇿 乌兹别克斯坦',
    vanuatu: '🇻🇺 瓦努阿图',
    venezuela: '🇻🇪 委内瑞拉',
    viet_nam: '🇻🇳 越南',
    virgin_islands: '🇻🇬 英属维尔京群岛',
    islands_us: '🇻🇮 美属维尔京群岛',
    wallis_futuna: '🇼🇫 瓦利斯和富图纳',
    western_sahara: '🇪🇭 西撒哈拉',
    yemen: '🇾🇪 也门',
    zambia: '🇿🇲 赞比亚',
    zimbabwe: '🇿🇼 津巴布韦',
  },

  miscellaneous: {
    tweel_url: '添加推文链接',
    divider: '分隔符',
    divider_cap: '分隔符',
    add_share: '添加分享块',
    add_countdown: '添加倒计时器',
    edit_countdown: '编辑倒计时器',
    enter_countdown_description: '输入倒计时描述',
    date_time: '日期和时间',
    add_action: '添加操作',
    add_faq: '添加常见问题',
    email_me: '给我发邮件',
    discount_plan: '选择代码的折扣在1%和99%之间',
    bulk_generator: '批量生成器',
  },

  edit_taxes: {
    create_new: '创建新税收',
    created_tax:
      '一旦创建了税收，就无法编辑或删除。创建税收后，您可以将其与创建的计划关联。',
    percentage: '百分比',
    taxes: '税收',
    edittax: '编辑税收',
    edit: '编辑',
    edit_cap: '编辑',
    description: '描述',
    tax_value: '税值',
    value_type: '值类型',
    fixed: '固定',
    inclusive: '包含',
    exclusive: '独家',
    personal_only: '仅个人',
    business_only: '仅业务',
    personal_business: '个人和业务',
    billing_for: '计费用途',
    countries: '国家',
    select: '选择要应用此税收的国家。如果要将税收应用于所有国家，请留空。',
  },

  planss: {
    edit_plan: '编辑计划',
    plan_features: '计划特性',
    set: '设置',
    for_unlimited: '无限制',
    total_amoutpage: '用户可创建的总生物链页面数量。',
    total_shortlink: '用户可创建的总缩短链接数量。',
    total_filelink: '用户可创建的总文件链接数量。',
    vcard_Limit: '用户可创建的名片链接总数。',
    totl_vcard: '用户可创建的总名片链接数量。',
    total_eventlinks: '用户可创建的总活动链接数量。',
    total_domain: '用户可添加的总自定义域数量。',
    link_state: '链接统计信息在数据库中保留的天数。',
    enable_blocks: '启用生物链块',
    select_blocks: '选择此计划上可用的生物链页面块。',
    state_retention: '链接统计信息保留时间（天）',
    custom_domain: '自定义域名限制',
    event_limit: '活动链接限制',
    file_limit: '文件链接限制',
    link_limit: '链接限制',
    blocks_limit: '每个生物链页面的生物链块限制',
    biolink_limit: '生物链限制',
    qr_limit: 'QR码限制',
    pixels_limits: '像素限制',
    project_limits: '项目限制',
    additional_block: '额外的全局域名',
    additional_blockDes:
      '启用此选项将使所有拥有此计划的人能够使用所有额外的全局域名。',
    back_half: '自定义后缀',
    back_halfDes:
      '启用此选项将使用户能够使用自定义URL别名而不是自动生成的别名。',
    deep_link: '深度链接',
    deep_linkDes:
      '启用此选项将使用户能够使用深度链接指向特定应用程序，而不仅限于http和https网址。',
    enable_ad: '启用此选项将使所有拥有此计划的人看不到任何广告',
    remove_brand: '可移动的页脚品牌',
    remove_brandDes: '这为用户提供了从生物链页脚删除品牌的选项。',
    button_url: '联系按钮网址',
    description: '描述',
    phone_collector: '电话收集器',
    email_collector: '电子邮件收集器',
    paragraph: '段落',
    custom_branding: '自定义页脚品牌',
    custom_brandingDes: '这为用户提供了在生物链页脚添加其自定义品牌的选项。',
    colored_links: '彩色链接',
    colored_linksDes: '用户可以自定义其生物链链接的颜色。',
    advanced_statistics: '高级统计',
    check_stat: '用户可以深入查看统计信息并选择时间范围',
    custom_backgrounds: '自定义背景',
    custom_backgroundDes:
      '用户可以在其生物链页面上添加自定义背景（颜色、渐变和实际图像）的能力。',
    temporary_URL: '临时网址',
    temporary_urlDes: '用户可以安排链接并限制点击次数的能力。',
    seo_des: '用户可以更改生物链页面的标题和Meta描述的能力',
    utm_des: '用户可以为生物链页面中的所有链接设置全局UTM参数的能力。',
    fonts_des: '用户可以从额外字体列表中选择其喜欢的字体的能力。',
    password_protection: '密码保护',
    password_protectionDes: '用户可以为其链接设置密码的能力。',
    sensitive_content: '敏感内容警告',
    sensitive_contentDes: '用户可以在其链接上启用敏感内容警告的能力。',
    leap_linkDes: '用户可以将生物链页面临时重定向到特定网址的能力。',
    dofollow_link: 'Dofollow生物链链接',
    dofollow_linkDes: '用户生物链链接将具有dofollow属性，否则默认为nofollow。',
    rest_api: '启用用户使用REST API的能力。',
    customcss_des:
      '启用为每个生物链页面添加自定义CSS的能力。请注意，只允许信任的人使用此功能。',
    customjs_des:
      '启用为每个vcard添加自定义js的能力。请注意，只允许信任的人使用此功能。',
    product_name: '产品名称',
    order: '订单',
    plan_name: '计划名称',
    action: '操作',
  },
  filtermodal: {
    all: '全部',
    unconfirmed: '未确认',
    admin_created: '管理员创建',
    admin_api: '管理员API创建',
    facebook_login: 'Facebook登录',
    twitter_login: 'Twitter登录',
    discord_login: 'Discord登录',
    google_login: 'Google登录',
    registration_date: '注册日期',
    ascending: '升序',
    descending: '降序',
    ten: '2',
    twentyfive: '3',
    fifty: '5',
    hundred: '7',
    twohundred: '10',
    fivehundred: '20',
    filters: '筛选器',
    order_by: '排序方式',
    results_page: '每页结果数',
    created_datetime: '创建日期时间',
    redeemable: '可赎回',
    dayss: '天',
    external_payment: '外部支付ID',
    paid: '已支付',
    pending: '待定',
    offline_payment: '离线支付',
    coinbase: 'Coinbase',
    payU: 'PayU',
    paystack: 'Paystack',
    razorpay: 'Razorpay',
    mollie: 'Mollie',
    yookassa: 'Yookassa',
    crypto: 'Crypto.com',
    paddle: 'Paddle',
    monthly_payments: '每月付款',
    missing_translation:
      'missing_translation: admin_payments.filters.order_by_name',
    missing_translate:
      'missing_translation: admin_payments.filters.order_by_email',
  },

  location: {
    addpin: '添加标记',
    cancel_adding_pin: '取消添加标记',
    adress: '地址',
    adress_placeholder: '123 Main St, City',
    phone: '电话',
    phone_placeholder: '123-456-7890',
    add_location: '添加位置',
    set_primary: '设为主要',
    primary_location: '主要位置',
    get_directions: '获取方向',
    added_any_location: '您尚未添加任何位置',
    adress_title_caps: '添加地址标题',
    adress_details_caps: '添加地址详情',
    enter_location_name: '输入位置名称',
    enter_location_adress: '输入位置地址',
    enter_location_phone: '输入位置电话',
    set_default_location: '将此位置设为您的主要/默认位置',
    home: '首页',
  },
  report: {
    report_abuse: '举报滥用',
    page_url: '页面网址',
    enter_page_url: '输入被举报的页面网址',
    report_type: '举报类型',
    reporter_type: '举报人类型',
    additional_comment: '附加评论',
    attachment: '附件',
    select_report_type: '选择举报类型',
    spam_scam_phishing: '垃圾邮件、诈骗或网络钓鱼',
    adult_content: '成人内容',
    illegal_goods_services: '非法商品和服务',
    fraud: '欺诈',
    child_abuse: '虐待儿童',
    shocking_violent_content: '令人震惊或暴力的内容',
    privacy_impersonation_harassment: '隐私、冒充和骚扰',
    gambling: '赌博',
    select_reporter_type: '选择举报人类型',
    bil_bio_user: 'Bil Bio用户',
    non_bil_bio_user: '非Bil Bio用户',
    legal_representative: '法定代表',
    law_enforcement: '执法部门',
    regulatory_body: '监管机构',
    child_abuse: '虐待儿童',
    shocking_violent_content: '令人震惊或暴力的内容',
    privacy_impersonation_harassment: '隐私、冒充和骚扰',
    gambling: '赌博',
    type_report_required: '需要举报类型',
    type_reporter_required: '需要举报人类型',
    comment_required: '需要评论',
    url_required: '需要页面网址',
    attachment_required: '需要附件',
    report_sentence: '通过此表格，您可以举报任何滥用 bil bio 的行为',
    site_protected: '该网站受 reCAPTCHA 和 Google 的保护',
    apply: '申请',
    your_submission_received: "您的提交已收到！",
    you_will_contacted: "如有需要，我们会与您联系。",
    go_home: "回家",
  },
  
    language_setting: {
      language_cap: '语言',
      update_with_unique_identity: '更新您的页面名称以创建您的独特身份',
      added_languge: '已添加语言',
      more_lang_cap: '添加更多语言',
      english: '英语',
      arabic: '阿拉伯语',
      sidebar_language: '语言',
      french: '法语',
      chinese: '中文',
      vietnamese: '越南语',
      search_other_lang: '搜索其他语言',
      english_default: '英语（默认）',
    },
    user_analytics: {
      analytics: '分析',
      some_states: '让我们今天检查一些统计数据！',
      feature_available: '此功能仅适用于',
      pro_user: '专业用户',
      upgrade: '升级到专业版',
      weak: '弱',
      month: '月',
      year: '年',
      custom_duration: '自定义时长',
      no_visitor: '访客数量',
      no_clicks: '点击数量',
      insta:'Instagram',
      twitter:'Twitter',
      youtube:'YouTube',
      linkedin:'LinkedIn',
      pinterest:'Pinterest',
      facebook:'Facebook',
      visitor_by_day: '按日和时间访客',
      sat: '星期六',
      sun: '星期日',
      mon: '星期一',
      tue: '星期二',
      wed: '星期三',
      thu: '星期四',
      fri: '星期五'
    },

    createPassword: {
      title: "输入密码",
      description: "输入密码以完成您的账户。",
      password: "密码",
      enterPassword: "输入密码",
      confirmPassword: "确认密码",
      enterConfirmPassword: "输入确认密码",
      accountAgreement: "创建账户即表示您同意我们的隐私政策和条款与条件。",
      createAccount: "创建账户",
      alreadyHaveAccount: "已经有账户了？",
      logIn: "登录",
    },

    privacy_title: "您的隐私对我们很重要",
    privacy_content: "Cookies 是您访问网站时存储在计算机上的非常小的文本文件。我们出于各种目的使用 cookies，以增强您在我们网站上的在线体验（例如，记住您的帐户登录详细信息）。您可以更改您的偏好，并拒绝在浏览我们网站时将某些类型的 cookies 存储在您的计算机上。您还可以删除已经存储在计算机上的任何 cookies，但请记住，删除 cookies 可能会阻止您使用我们网站的某些部分。",
    strictly_necessary_title: "严格必要的 cookies",
    strictly_necessary_content: "这些 cookies 对于通过我们的网站向您提供服务以及使您能够使用我们网站的某些功能是必不可少的。没有这些 cookies，我们无法在我们的网站上为您提供某些服务。",
    functionality_title: "功能性 cookies",
    functionality_content: "这些 cookies 用于为您提供更个性化的体验，并记住您使用我们网站时所做的选择。例如，我们可能会使用功能性 cookies 来记住您的语言偏好或登录详细信息。",
    tracking_title: "跟踪 cookies",
    tracking_content: "这些 cookies 用于收集信息以分析我们网站的流量以及访问者如何使用我们的网站。例如，这些 cookies 可能会跟踪您在网站上停留的时间或访问的页面，这有助于我们了解如何改进我们的网站。通过这些跟踪和性能 cookies 收集的信息不会识别任何个人访问者。",
    targeting_advertising_title: "目标和广告 cookies",
    targeting_advertising_content: "这些 cookies 用于根据您的浏览习惯显示可能对您感兴趣的广告。这些 cookies 由我们的内容和/或广告提供商提供，可能会将它们从我们网站收集的信息与它们独立收集的与您的网络浏览器在其网站网络上的活动有关的其他信息相结合。如果您选择删除或禁用这些目标或广告 cookies，您仍然会看到广告，但这些广告可能与您无关。",
    more_info_title: "更多信息",
    more_info_content: "如有任何关于我们 cookies 政策及您的选择的查询，请联系我们。",
    
  your_privacy: '您的隐私',
  strict_necessary_cookies: '严格必要的 cookies',
  functionality_cookies: '功能性 cookies',
  tracking_cookies: '跟踪 cookies',
  targeting_cookies: '目标和广告 cookies',
  more_info: '更多信息',
  cookies_preference_center: 'Cookies 首选项中心',
  always_active: '始终活跃',
  in_active: '不活跃',
  cookies_consent: '由 Cookie 同意',
  terms_feed: 'Feed 条款',
  save_my_preferences: '保存我的偏好',
  active: '活跃',
  read_more: "阅读更多",
  read_less: "阅读更少",

  want_to_delete: '您确定要删除此项吗？',
  get_started_now: '立即开始',
  join_waiting_list: '加入等待列表',
  package_suitable_people: '此套餐适合 1-15 人的团队。',
  my_location: "我的位置",
  be_the_first_to: "成为第一个",
  bil_bio: "比尔比奥",
  experience: "经验",
  waitlist_early_access: "立即注册加入抢先体验等候名单。成为我们旅程的一部分！",
  you_are_waitlist: "您已在候补名单上！",
  thanks_joining_waitlist: "感谢您加入我们的候补名单！随着我们即将推出新平台，您将成为第一批获知消息的人。请继续关注更新和独家见解。我们很高兴您能和我们在一起！",
  main_title_part_one: "建立一个单一链接",
  main_title_part_two: "对于您的所有链接",
  no_blocks_found: "未找到任何块！",
  lorem_ipsum_dolor: "Lorem ipsum dolor sat amet，consectetur adipiscing elit。 Elit urna dictum placerat urna iaculis",
}

export default cn
